import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/internal/operators';

import { MyApp } from '../common/enumerations';
import { ServiceManagerBase } from '../common/service-manager-base';
import { OrganizationApiService } from './organization-api.service';
import { BroadcastService } from '../../core/services/broadcast.service';
import { ItemsCollection } from '../common/items-collection.model';
import { CachedCollection } from '../common/cached-collection.model';
import { OrganizationListItem } from './organization-list-Item.model';
import { Organization } from './organization.model';
import { ImageAsset } from '../images/image-asset-model';
import { ImageManagerService } from '../images/image-manager.service';

export enum ViewMode
{
    Album,
    Folder,
}

@Injectable({
    providedIn: 'root',
})
export class OrganizationManagerService extends ServiceManagerBase
{
    viewMode = window.location.href.indexOf('doc-center') !== -1 ? ViewMode.Folder : ViewMode.Album;

    // Cache Containers
    private _organizationsCollection: CachedCollection;
    private _currentOrganization: Organization;

    constructor(private organizationApiService: OrganizationApiService,
                protected broadcastService: BroadcastService,
                private imageManager: ImageManagerService)
    {
        super(broadcastService);
    }

    get currentOrganization(): Observable<Organization>
    {
        if (this._currentOrganization)
        {
            return of(this._currentOrganization);
        }

        return this.organizationApiService.getCurrentOrganization()
            .pipe(
                tap(org => this._currentOrganization = org )
            );
    }

    getCurrentOrganizationImages(): Observable<Organization>
    {
        if (this._currentOrganization == null || this._currentOrganization.Logo != null || this._currentOrganization.Photo != null || this._currentOrganization.WelcomeImage != null) return of(this._currentOrganization);
        return this.organizationApiService.getCurrentOrganizationImages().pipe(map(json =>
        {
            if (json['Logo'] != null) this._currentOrganization.Logo = new ImageAsset(json['Logo']);
            if (json['Photo'] != null) this._currentOrganization.Photo = new ImageAsset(json['Photo']);
            if (json['WelcomeImage'] != null) this._currentOrganization.WelcomeImage = new ImageAsset(json['WelcomeImage']);
            return this._currentOrganization;
        }));
    }

    switchingOrganizations()
    {
        this._currentOrganization = null;
    }

    protected clearCache()
    {
        // Clean-up any cached collections here.
    }

    getOrganizations(sortField?: string, sortOrder?: MyApp.SortOrder, pageIndex = 0, pageSize = this.defaultPageSize, bypassCache = false): Observable<ItemsCollection<OrganizationListItem>>
    {
        if (!bypassCache && this._organizationsCollection && !this._organizationsCollection.isExpired)
        {
            return of(this._organizationsCollection.collection);
        }

        return this.organizationApiService.getOrganizations(sortField, sortOrder, pageIndex, pageSize)
            .pipe(
                tap(response => this._organizationsCollection = new CachedCollection(response))
            );
    }
}
